import SaleFormComponent from 'components/forms/sale';
import {Form, Formik} from 'formik';
import Header from 'modules/header/wholesaler/main';
import Description from 'pages/farm/createAd/form/owner/sale/description';
import {formDataCreator} from '../../utilities/formDataCreatot';
import {initialValues} from './utilities/initialValues';
import {schema} from './utilities/validationSchema';
import {useWholesaler} from 'context/wholesaler';
import usePostAd from '../../hooks/usePostAd';
import useSetAnswers from 'pages/farm/createAd/form/owner/simple/hooks/useSetAnswers';
import {useState} from 'react';
import {googleAnalyticsInstance} from 'utilities/helper/googleAnalitics';
import {WholesalerEvent} from 'utilities/helper/googleAnalitics/EventHelper';

const SaleForm = () => {
  const {wholesaler} = useWholesaler();
  const {isLoading, mutate} = usePostAd();
  const {answers, handleAnswers} = useSetAnswers();
  const [isChecked, setIsChecked] = useState<boolean>(false);
  return (
    <>
      <Header title="ثبت آگهی فروش محصول " />
      <Description />
      <Formik
        initialValues={initialValues}
        validationSchema={schema}
        onSubmit={values => {
          const payload = new FormData();
          formDataCreator(payload, wholesaler);
          payload.append('price', values.price);
          payload.append('min_price', values.min_price);
          payload.append('duration', values.duration);
          payload.append('duration_unit', values.duration_unit);
          payload.append('decline_rate', values.decline_rate);
          payload.append('rate_unit', values.rate_unit);
          if (answers.length > 0 && isChecked) {
            const answersGuid: string[] = [];
            answers.map(item => answersGuid.push(item.guid));
            payload.append('answers', answersGuid.toString());
          }
          !isLoading && mutate(payload);
          googleAnalyticsInstance.eventGoogleAnalytics(
            WholesalerEvent.addedSale,
          );
        }}
      >
        {({values}) => (
          <Form className="px-3 pb-4">
            <SaleFormComponent
              values={values}
              isLoading={isLoading}
              subProduct={wholesaler?.subProduct}
              handleAnswers={handleAnswers}
              answers={answers}
              isChecked={isChecked}
              setIsChecked={setIsChecked}
            />
          </Form>
        )}
      </Formik>
    </>
  );
};

export default SaleForm;
